import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";


import cyber2 from "assets/img/cyber2.jpg";


import ev3 from "assets/img/EV3.jpg";
import ev4 from "assets/img/EV4.jpg";

import ilbc from "assets/img/ilbc.jpg";
import ilbc1 from "assets/img/ilbc1.jpg";
import ilbc2 from "assets/img/ilbc2.jpg";
import ilbc3 from "assets/img/ilbc3.jpg";
import ilbc4 from "assets/img/ilbc4.jpg";
import ilbc5 from "assets/img/ilbc5.jpg";
import ilbc6 from "assets/img/ilbc6.jpg";


import uit from "assets/img/uit.jpg";
import uit1 from "assets/img/uit1.jpg";
import uit2 from "assets/img/uit2.jpg";
import uit3 from "assets/img/uit3.jpg";
import uit4 from "assets/img/uit4.jpg";
import uit5 from "assets/img/uit5.jpg";
import uit6 from "assets/img/uit6.jpg";


import ict2 from "assets/img/ict2.jpg";

import ict4 from "assets/img/ict4.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
              <div>
                    <img
                      src={ilbc}
                      alt="ILBC"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>
                 
                   <div>
                    <img
                      src={ilbc1}
                      alt="ILBC"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>
                   <div>
                    <img
                      src={ilbc2}
                      alt="ILBC"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>
                   <div>
                    <img
                      src={ilbc3}
                      alt="ILBC"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>

                   <div>
                    <img
                      src={ilbc4}
                      alt="ILBC"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>

                   <div>
                    <img
                      src={ilbc5}
                      alt="ILBC"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>

                   <div>
                    <img
                      src={ilbc6}
                      alt="ILBC"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>
                  
                  <div>
                    <img
                      src={ev3}
                      alt="EV"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>EV Association Preparation in Myanmar
                      </h4>
                    </div>
                  </div>
                  <div>
                    <img
                      src={ev4}
                      alt="EV"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>EV Association Preparation in Myanmar
                      </h4>
                    </div>
                  </div>

                  <div>
                    <img
                      src={cyber2}
                      alt="Cyber Security Presentation with Pwc"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Cyber Security Presentation with Pwc
                      </h4>
                    </div>
                  </div>
                   
                  
                    <div>
                    <img
                      src={uit}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={uit1}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>



                    <div>
                    <img
                      src={uit2}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={uit3}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={uit4}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>
                  <div>
                    <img
                      src={uit5}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={uit6}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>
                    
                 


                    <div>
                    <img
                      src={ict2}
                      alt="ICT"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Water Distribution Plant
                      </h4>
                    </div>
                  </div>

                   
                    <div>
                    <img
                      src={ict4}
                      alt="ICT"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Redundant Power Paths
                      </h4>
                    </div>
                  </div>
                


                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);


// WEBPACK FOOTER //
// ./src/views/ICTPage/Sections/SectionCarousel.jsx